import LinkLookup from 'components/LinkLookup';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import SettingSidebar from 'components/Navbar/SettingsSidebar';
import SeatsTable from 'components/UsersList/SeatsTable';
import React from 'react';
import { useSelector } from 'react-redux';
import { getCohort, getCohortsLoading, getUpsertCohortLoading } from 'selectors/cohorts';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import CohortAuditoLogsList from './CohortAuditoLogsList';
import CohortStats from './CohortStats';
import SOWDetails from './SOWDetails';

const Cohort: React.FC = () => {
  const fetchLoading = useSelector(getCohortsLoading);
  const upsertLoading = useSelector(getUpsertCohortLoading);
  const cohort = useSelector(getCohort);

  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <div
      className="min-w-screen bg-white"
      style={{
        height: `calc(100vh - ${warningBarOffset}px)`,
      }}
    >
      <Navbar />
      <div
        className="flex flex-row"
        style={{
          height: `calc(100vh - ${warningBarOffset}px - ${NAV_BAR_HEIGHT_REM}rem)`,
        }}
      >
        <SettingSidebar />
        <div className="w-full h-full px-10 pt-6 pb-6 flex flex-col gap-3 overflow-hidden">
          {!cohort ? (
            <div className="w-full h-full flex justify-center items-center">
              <LoadingIndicator size="20" />
            </div>
          ) : (
            <>
              <header className="flex flex-col gap-3">
                <div className="flex flex-row gap-1 items-start text-body">
                  <LinkLookup
                    routeName="customer"
                    className="text-body hover:underline"
                    data-testid="customer-button"
                  >
                    General
                  </LinkLookup>
                  &gt;
                  <LinkLookup
                    routeName="customer-overview"
                    className="text-body hover:underline"
                    data-testid="customer-button"
                  >
                    Account Overview
                  </LinkLookup>
                  &gt;
                  <div>{cohort?.name}</div>
                </div>

                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-row items-center">
                    <h1 className="text-heading-1">{cohort?.name}</h1>
                    {(upsertLoading || fetchLoading) && (
                      <LoadingIndicator className="ml-2" size="5" />
                    )}
                  </div>

                  {(!cohort.config.sync_start_date ||
                    cohort.users === undefined ||
                    (cohort.users && cohort.users.length === 0)) && (
                    <LinkLookup
                      routeName="customer-cohort-import"
                      routeParams={{ cohortId: cohort.uuid }}
                      className="button button--primary w-37 h-8 font-bold justify-center whitespace-no-wrap"
                      data-testid="generate-assessment-button"
                    >
                      Import Data
                    </LinkLookup>
                  )}
                </div>
              </header>
              <div className="flex flex-row gap-6 justify-between items-start">
                <SOWDetails cohort={cohort} />
                <div className="flex flex-col gap-4">
                  <SeatsTable cohortId={cohort.uuid} />
                  <CohortStats cohort={cohort} />
                </div>
              </div>
              <main className="flex flex-col h-full overflow-hidden">
                <CohortAuditoLogsList />
              </main>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cohort;
